export default __webpack_public_path__ + "static/yardmap-e86677417aad064183c63a1bcbcd5581.png";